export * from "./vendas-por-mes.component";
